import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { formatSpacedNumber } from '../../../../../../utils/format';
import { DebtFormGroupData } from '../../../../FormData.fi.types';
import { gridColumns } from '../../../config/layouts/grid';
import {
  debtCarMonthlyDebtPaymentFieldOption,
  debtCarOutstandingAmountFieldOption,
} from './config';

export const DebtFormGroup = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const { axoFormData } = useAxoFormContext();

  const maritalStatus = axoFormData['LoanApplication/MaritalStatus'];

  const carDebt = Number(watch('Debt/Car/OutstandingAmount'));

  return (
    <Grid columns={gridColumns}>
      <NumberFieldUI<DebtFormGroupData>
        name="Debt/Car/OutstandingAmount"
        label={t('Debt.Car.OutstandingAmount.label', {
          context: maritalStatus,
        })}
        data-testid="debt-car-outstanding-amount-input"
        format={formatSpacedNumber}
        suffix={t('suffix.currency')}
        {...debtCarOutstandingAmountFieldOption}
      />

      {carDebt > 0 && (
        <NumberFieldUI<DebtFormGroupData>
          name="Debt/Car/MonthlyDebtPayment"
          label={t('Debt.Car.MonthlyDebtPayment.label')}
          data-testid="debt-car-monthly-debt-payment-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...debtCarMonthlyDebtPaymentFieldOption}
        />
      )}
    </Grid>
  );
};
